/* eslint-disable */
// import axios from 'axios';
import Util from './util.js';
import {login_url, error_code_40001, error_code_400003} from './const.js';
import { Message } from 'element-ui';
import util from "./util";
import './axios-config';
const serverErrorHandler = function (response) {
    if (!response) {
        return;
    }
    let data = response.data;
    let code = data.code;
    let reqUrl = response.config.url;
    let errorMsg = code === 404 ? pathNotFound(reqUrl) : data.message;
    if (errorMsg) {
        winError(errorMsg);
    }
};
const clientErrorHandler = function (error) {
    if (!error) {
        return;
    }
    console.info('http.js error', error);
    let status = error.request.status;
    let reqUrl = error.request.responseURL;
    let errorMsg = status === 404 ? pathNotFound(reqUrl) : error.message;
    if (errorMsg) {
        winError(errorMsg);
    }
};
const pathNotFound = function (path) {
    return '请求路径未找到 : ' + path;
};
const durationTime = 10*3000;
const winError = function (errorMsg) {
   if (!window.hasMsgWin) {
       window.hasMsgWin = true;
       Message.error({
           message: errorMsg,
           duration: durationTime,
           showClose: true,
           onClose: function () {
               window.hasMsgWin = false;
           }
       });
   }
};

axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
const forwardToYKT = function (yktUrl) {
    util.clearYKTCache();
    window.location.href = util.getYktUrl(yktUrl);
}
const notValidation = [200, 301, error_code_40001, error_code_400003, 401];
axios.interceptors.response.use(function (response) {
    if(response.status !== 200){
        return response;
    }
    let code = response.data.code;
    // 未登录 后端返回401 ， loginAuth控制未登录是否跳转到登录，前端联调时，有时不需要登录验证直接调用api
    let hasLogin = process.env.VUE_APP_HAS_LOGIN === 'true' ? true:false;
    if (hasLogin && code === 401) {
        let yktUrl = util.getYKTCache();
        if(yktUrl) {
            forwardToYKT(yktUrl);
        }else{
            let urlHash = encodeURIComponent(`${location.origin}/#${util.fullPath}`);
            window.location.href = `${login_url}?redirectUrl=${urlHash}`;
        }
    }
   if (notValidation.indexOf(code) === -1) {
        let yktUrl = util.getYKTCache();
        if(yktUrl) {
            forwardToYKT(yktUrl);
        }else{
            serverErrorHandler(response);
        }
    }
    return response;
}, function (error) {
    // 对响应错误做点什么
    clientErrorHandler(error);
    return error;
});
export default axios;
